<template lang="html">
	<div id="page__airportluws" class="center-panel">
		<md-content md-theme="white" v-bind:loading="progress">
			<AirportsMenu></AirportsMenu>
			<sort-table
				v-bind:columns="tableColumns" v-model="prices" v-on:refresh="getPrices" v-bind:per-page="perPage" 
				v-bind:total="pricesAmount" link table-id="airportluws" ref="table" v-on:create="addPrice" tableHeight="calc(100% - 48px)"
			>
				<template slot="actions" slot-scope="scope">
                    <z-icon-button v-bind:icon="['fa', 'trash']" v-on:click.stop.prevent="onRemove(scope.item.id)" danger-light rounded></z-icon-button>
                </template>
			</sort-table>
		</md-content>
	</div>
</template>
<script>
	import AirportsMenu from './AirportsMenu.vue';
	import SortTable from '@/components/SortTable';
	import ZIconButton from '@/components/ZIconButton.vue';
	export default {
		components: { SortTable, ZIconButton, AirportsMenu },
		data() {
			return {
				title: 'Погрузочно-разгрузочные рыботы в аэропорту',
				perPage: 50,
				tableColumns: [
					{ label: 'ID',  field: 'id',   default: true, sortable: true },
					{ label: 'Тип', field: 'type_name', sortable: true },
					{ label: 'Минимальный',     field: 'is_min_name', sortable: false},
					{ label: 'Цена (руб.)',     field: 'price',       sortable: true },
					{ label: 'Вес/Объём мин.',  field: 'value_min',   sortable: true },
					{ label: 'Вес/Объём макс.', field: 'value_max',   sortable: true },
					{ label: '', field: 'actions' }
				],
			}
		},
		computed: {
			/**
             * Флаг загрузки текущего компонента
             */
            progress() {
                return this.progressObj['get-airportluws-list'];
            },
            /**
             * Объект с флагами загрузки
             */
            progressObj() {
                return this.$store.state.progressObj;
            },
			/**
			 * Список 
			 */
             prices() {
				return this.$store.state.cost.airport_luws.map(item => {
					item.routerLink = {name: 'AirportLuwPrice', params: {id: item.id}, query: this.$route.query};
                    item.type_name   = parseInt(item.type) === 1 ? 'По весу' : parseInt(item.type) == 2 ? 'По объёму' : 'Не определено'
					item.is_min_name = parseInt(item.is_min) === 1 ? 'Да' : 'Нет'
					return item;
				});
			},
			/**
			 * Количество 
			 */
             pricesAmount() {
				return this.$store.state.cost.airport_luws_amount
			}
		},
		created() {
			this.$store.commit('setTitle', this.title)
		},
		methods: {
			/**
			 * Добавление города
			 */
			addPrice() {
				this.$router.push({ name: 'AirportLuwPrice', params: {id: 'new'} });
			},
			/**
			 * Получение городов
			 */
			getPrices(page, count, orderBy, orderType, filter) {
				this.$store.commit('showProgressBar', 'get-airportluws-list');
				return this.$store.dispatch('cost/getAirportLuws', {
					page: page, 
					order_by: orderBy, 
					order_type: orderType, 
					count: count,
					filter: this.resolveQueryFilter()
				}).finally(() => this.$store.commit('hideProgressBar', 'get-airportluws-list'));
			},
			/**
			 * Фильтрация
			 */
			resolveQueryFilter() {
				if (!this.$route.query || !this.$route.query.filter) return null;
				let filter = Object.assign({}, JSON.parse(this.$route.query.filter)), model = [], result = {model: [], relation: [], condition: 'and'};

                if (filter.type)    model.push(['type',    '=', filter.type]);
                if (filter.city_id) model.push(['city_id', '=', filter.city_id]);
                if (filter.zone_id) model.push(['zone_id', '=', filter.zone_id]);

                model.map((item, i) => {
                    result.model.push(item);
                    if (model[i+1]) result.model.push('and');
                });

				return result;
			},
			/**
			 * Удаление города
			 */
			removePrice(id) {
				if (!id) return;
				this.$store.commit('showProgressBar', 'get-airportluws-list');
				this.$store.dispatch('cost/deleteAirportLuw', id)
					.then(() => this.$root.$emit('refresh-table', 'airportluws'))
					.finally(() => this.$store.commit('hideProgressBar', 'get-airportluws-list'));
			},
			/**
			 * Модальное окно с подтверждением удаления города
			 */
			onRemove(id) {
                this.$root.$emit(
                    'z-alert', 'Вы уверены в удалении цены?', 'Действие необратимо!',
                    () => this.removePrice(id)
                );
            },
		},
	}
</script>


// WEBPACK FOOTER //
// AirportLuws.vue?28783635